import React, { useState } from 'react';
import { Stepper, GetInfo } from '@operations/shared';
import { userRefundExcessApi } from '../../utils/apisConsts';
import SubmitRefundExcess from './submitRefundExcess';
export const ViewRefundExcess: React.FC = () => {
    const [componentSteps] = useState([
        {
            title: 'Get User',
            content: <GetInfo apiLink={userRefundExcessApi} isApplyingPhoneAndID />,
            id: 0,
        },
        {
            title: 'Refund Excess Amount',
            content: <SubmitRefundExcess/>,
            id: 1,
        },
    ]);

    return (
        <>
            <Stepper componentSteps={componentSteps} />
        </>
    );
};

